import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "q-pa-lg row justify-center" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_card_actions = _resolveComponent("q-card-actions");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_page = _resolveComponent("q-page");
    return (_openBlock(), _createBlock(_component_q_page, { class: "full-width" }, {
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_q_card, { class: "col-12 col-xl-10 col-lg-10 col-md-10" }, {
                    default: _withCtx(() => [
                        _createVNode(_component_q_card_section, { class: "bg-white" }, {
                            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                    _createElementVNode("div", { class: "text-h4 text-bold text-green-7" }, "パスワード再発行完了", -1)
                                ]))]),
                            _: 1
                        }),
                        _createVNode(_component_q_separator),
                        _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                    _createElementVNode("div", { class: "q-pa-md" }, [
                                        _createElementVNode("div", { class: "table-caption" }, [
                                            _createTextVNode(" 登録されている携帯電話番号宛に、SMSを送信しました。"),
                                            _createElementVNode("br"),
                                            _createTextVNode(" SMSに記載されている内容をご確認のうえ、ログインを行ってください。"),
                                            _createElementVNode("br"),
                                            _createElementVNode("br"),
                                            _createTextVNode(" しばらく経ってもSMSが届かない場合、"),
                                            _createElementVNode("br"),
                                            _createTextVNode(" 恐れ入りますが、ログイン画面に戻った後もう一度パスワード再発行をお試しください。"),
                                            _createElementVNode("br")
                                        ])
                                    ], -1)
                                ]))]),
                            _: 1
                        }),
                        _createVNode(_component_q_card_actions, {
                            class: "q-pb-lg row",
                            align: "center"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_q_btn, {
                                    label: "ログイン画面へ",
                                    class: "btn-route col-8 col-md-4",
                                    color: "green-7",
                                    "icon-right": "navigate_next",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$router.push({ name: 'login' })))
                                })
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                })
            ])
        ]),
        _: 1
    }));
}
